export default __webpack_public_path__ + "static/media/designSystemImage.b6ba626b.svg";